var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("common.entity_account.entity_account_details_file"),
      },
    },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.listItemsEntityAccountFile.length > 0
                ? [
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("common.entity_account.details"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .DateStartImport !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.date_start_import"
                                            ),
                                            inputValue: _vm.getDateImport(
                                              _vm.listItemsEntityAccountFile[0]
                                                .DateStartImport
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.date_start_import"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "common.entity_account.processing_time"
                                        ),
                                        inputValue: _vm.processingDuration,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-col", {
                                  staticClass: "mb-5",
                                  attrs: { sm: "4" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .FileName !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_name"
                                            ),
                                            inputValue:
                                              _vm.listItemsEntityAccountFile[0]
                                                .FileName,
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_name"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .FileReference !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_reference"
                                            ),
                                            inputValue:
                                              _vm.listItemsEntityAccountFile[0]
                                                .FileReference,
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_reference"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0].Bic !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.bic"
                                            ),
                                            inputValue:
                                              _vm.listItemsEntityAccountFile[0]
                                                .Bic,
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.bic"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0].Status !==
                                    ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_status"
                                            ),
                                            inputValue: _vm.$t(
                                              "common.entity_account.file_status_" +
                                                _vm
                                                  .listItemsEntityAccountFile[0]
                                                  .Status
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.file_status"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .SynchroType !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.synchro_type"
                                            ),
                                            inputValue: _vm.$t(
                                              "common.entity_account.synchro_type_" +
                                                _vm
                                                  .listItemsEntityAccountFile[0]
                                                  .SynchroType
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.synchro_type"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _vm.listItemsEntityAccountFile[0]
                                      .ImportResult !== ""
                                      ? _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.import_result"
                                            ),
                                            inputValue: _vm.$t(
                                              "common.entity_account.import_result_" +
                                                _vm
                                                  .listItemsEntityAccountFile[0]
                                                  .ImportResult
                                            ),
                                          },
                                        })
                                      : _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.import_result"
                                            ),
                                            inputValue: "-",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                [
                                  "5",
                                  "6",
                                  "7",
                                  "8",
                                  "9",
                                  "20",
                                  "21",
                                  "22",
                                ].includes(
                                  _vm.listItemsEntityAccountFile[0].Status
                                )
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "common.entity_account.provider_message_identifier"
                                            ),
                                            inputValue:
                                              _vm.listItemsEntityAccountFile[0]
                                                .ProviderMessageIdentifier,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                [
                                  "5",
                                  "6",
                                  "7",
                                  "8",
                                  "9",
                                  "20",
                                  "21",
                                  "22",
                                ].includes(
                                  _vm.listItemsEntityAccountFile[0].Status
                                )
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        ["22"].includes(
                                          _vm.listItemsEntityAccountFile[0]
                                            .Status
                                        )
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "common.entity_account.provider_rejection_reason"
                                                ),
                                                inputValue:
                                                  _vm
                                                    .listItemsEntityAccountFile[0]
                                                    .ProviderRejectionReason,
                                              },
                                            })
                                          : _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "common.entity_account.provider_rejection_reason"
                                                ),
                                                inputValue: "-",
                                              },
                                            }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("b-col", {
                                  staticClass: "mb-5",
                                  attrs: { sm: "4" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mx-auto" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t(
                                "common.entity_account.file_history"
                              ),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.listItemsEntityAccountFileHistory.length > 0
                              ? _c(
                                  "table",
                                  {
                                    staticClass: "table table-striped w-50",
                                    staticStyle: { margin: "0 auto" },
                                  },
                                  [
                                    _c(
                                      "tbody",
                                      [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.entity_account.date_action"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.entity_account.file_status"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { staticClass: "text-center w-25" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.entity_account.additional_information"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.listItemsEntityAccountFileHistory,
                                          function (his) {
                                            return _c(
                                              "tr",
                                              {
                                                key: _vm
                                                  .listItemsEntityAccountFileHistory
                                                  .IdEntityAccountFile,
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    his.DateAction !== ""
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getDate(
                                                                his.DateAction
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    his.Status !== ""
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.entity_account.file_status_" +
                                                                  his.Status
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-center w-25",
                                                  },
                                                  [
                                                    his.AdditionalInformation !==
                                                    ""
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              his.AdditionalInformation
                                                            )
                                                          ),
                                                        ])
                                                      : _c("div", [
                                                          _vm._v(" - "),
                                                        ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }